var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19C18.5523 19 19 19.4477 19 20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20C5 19.4477 5.44772 19 6 19H18ZM12 3C12.5523 3 13 3.44772 13 4V13.5859L14.793 11.793C15.1835 11.4024 15.8165 11.4024 16.207 11.793C16.5976 12.1835 16.5976 12.8165 16.207 13.207L12.707 16.707C12.3165 17.0976 11.6835 17.0976 11.293 16.707L7.79297 13.207C7.40244 12.8165 7.40244 12.1835 7.79297 11.793C8.18349 11.4024 8.81651 11.4024 9.20703 11.793L11 13.5859V4C11 3.44772 11.4477 3 12 3Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.e339dd02d2cd198a277e7607cb352ea5.svg";
export { ForwardRef as ReactComponent };